import React from 'react'
import { Flex, FlexProps } from 'rebass/styled-components'

import Search from '../Forms/Search'

export interface SearchFieldProps extends Omit<FlexProps, 'onChange'> {
  placeholder: string
  onChange: (value: string) => void
}

export const SearchField = ({ onChange, placeholder, sx, ...props }: SearchFieldProps): JSX.Element => (
  <Flex data-name="SearchField" sx={{ ...sx }} {...props}>
    {/* @ts-ignore (tsc erroring due to the onChange prop; Search is still a JSX file so ignoring for now */}
    <Search onChange={onChange} placeholder={placeholder} />
  </Flex>
)
